const MINIMUM_POLL_MS = 60_000;

export function visibleInterval(ms: number): () => number | false {
  const every = Math.max(ms, MINIMUM_POLL_MS);
  return () => (typeof document !== 'undefined' && document.visibilityState === 'visible' ? every : false);
}
